import { generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("Custom Animation", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  animationId: generateStringSchema("Animation ID", "The animation ID to use."),
}));
